import './PainPointsSection.css';

export function PainPointsSection() {
  return (
    <section className="pain-points" aria-labelledby="pain-points-heading">
      <div className="container">
        <header className="pain-points__header">
          <h2 id="pain-points-heading" className="pain-points__title">
            Your Business Deserves More Reviews
          </h2>
          <p className="pain-points__subtitle">
            Your customers are happy. You make sure the job is done right. But when
            it comes time to get a review... silence.
          </p>
        </header>

        <div className="pain-points__cards">
          <article className="pain-card pain-card--reviews">
            <h3 className="pain-card__title">No Reviews</h3>
            <p className="pain-card__text">
              You have lots of happy customers but only a few reviews to show for
              it. So you have to prove yourself to new leads.
            </p>
            <div
              className="gmb-mock"
              aria-label="Example Google Business listing with no reviews"
            >
              <p className="gmb-mock__name">Smile Pest Control</p>
              <p className="gmb-mock__meta">
                <span className="gmb-mock__no-reviews">No reviews</span>
                {' • Pest Control'}
              </p>
              <p className="gmb-mock__years">3+ years in business</p>
              <ul className="gmb-mock__actions">
                <li>
                  <svg className="gmb-mock__icon" viewBox="0 0 24 24" aria-hidden="true">
                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="M3 12h18M12 3a15 15 0 010 18M12 3a15 15 0 000 18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                  </svg>
                  Website
                </li>
                <li>
                  <svg className="gmb-mock__icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fill="currentColor"
                      d="M6.6 10.8c1.4-2.6 3.9-4.5 6.9-5.1-.7 3.8-2.8 6.9-6.2 8.3l-.7-3.2zm8.4 1.2c-.5 2.9-2.4 5.3-5.1 6.5l-.6-2.8c2-.9 3.5-2.6 4.3-4.6l1.4.9z"
                    />
                  </svg>
                  Call
                </li>
                <li>
                  <svg className="gmb-mock__icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M12 2L4 12h6v10h4V12h6L12 2z" />
                  </svg>
                  Directions
                </li>
              </ul>
            </div>
          </article>

          <article className="pain-card pain-card--time">
            <h3 className="pain-card__title">No Time</h3>
            <p className="pain-card__text">
              As a business owner, you don&apos;t have the time to chase customers
              down to ask for a review. You&apos;re wearing enough hats already.
            </p>
          </article>

          <article className="pain-card pain-card--visibility">
            <h3 className="pain-card__title">No Visibility On Google</h3>
            <p className="pain-card__text">
              Your ideal customers are choosing your competition over you just
              because of their reviews. You know you do better work, but new
              customers don&apos;t.
            </p>
            <div className="visibility-chart" aria-hidden="true">
              <span className="visibility-chart__badge">
                -23%
                <svg viewBox="0 0 12 12" width="12" height="12">
                  <path d="M6 9L2 4h8L6 9z" fill="currentColor" />
                </svg>
              </span>
              <div className="visibility-chart__bars">
                <span style={{ height: '72%' }} />
                <span style={{ height: '58%' }} />
                <span style={{ height: '44%' }} />
                <span style={{ height: '32%' }} />
                <span style={{ height: '20%' }} />
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
